export default "__VITE_ASSET__CXIgj1qI__"